import { Component, Inject, OnInit } from '@angular/core';
import { FormService } from "../../services/form.service";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component( {
	selector: 'app-possible-matches',
	templateUrl: './possible-matches.component.html',
	styleUrls: ['./possible-matches.component.scss']
} )
export class PossibleMatchesComponent implements OnInit {

	public movers: any;
	public serviceProviders: any;

	constructor( private formService: FormService,
	             @Inject(MAT_DIALOG_DATA) data: { movers: any, service_providers: any } ) {

		this.movers = data.movers;
		this.serviceProviders = data.service_providers;
	}

	ngOnInit(): void {
	}
}
